
import React from "react";
import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function QueEsSection() {
  return (
    <PostSection id="que-es-vibe-coding" title="Qué es exactamente el vibe coding">
      <p className="text-gray-300 mb-6">
        El término lo acuñó <strong className="text-white">Andrej Karpathy</strong>, cofundador de OpenAI, a principios de 2025. La idea es simple pero radical: en lugar de escribir código línea a línea, describes lo que quieres construir en lenguaje natural y la IA lo genera por ti. Tú revisas, corriges el rumbo, iteras. No necesitas saber programar. Solo necesitas saber qué quieres construir y tener criterio para evaluar si funciona.
      </p>

      <h3 id="origen" className="text-xl font-semibold text-white mt-8 mb-4">
        Origen del término
      </h3>
      <p className="text-gray-300 mb-6">
        El nombre viene de la sensación que produce: estás en un estado de flujo creativo, describiendo ideas, y la aplicación va tomando forma casi en tiempo real. Das feedback, ajustas, afinas. Es más parecido a diseñar que a programar.
      </p>

      <PostHighlight>
        <p className="text-gray-300">
          Con el vibe coding no escribes código. Describes lo que quieres, la IA genera código real, y tú diriges el resultado como un director creativo.
        </p>
      </PostHighlight>

      <h3 id="diferencia-nocode" className="text-xl font-semibold text-white mt-8 mb-4">
        Diferencia con el no-code tradicional
      </h3>
      <p className="text-gray-300 mb-4">
        La diferencia con el no-code tradicional es fundamental. Herramientas como Webflow o WordPress te dan bloques prefabricados que ensamblas. El vibe coding genera <strong className="text-white">código real, a medida</strong>, que puedes modificar, exportar y escalar sin los límites de una plataforma cerrada.
      </p>
      <ul className="list-disc pl-5 text-gray-300 space-y-2 mb-6">
        <li>No-code tradicional: bloques predefinidos, personalización limitada, dependencia de la plataforma.</li>
        <li>Vibe coding: código generado a medida, exportable, escalable, sin restricciones técnicas.</li>
        <li>El resultado es tuyo: puedes llevártelo, modificarlo, desplegarlo donde quieras.</li>
      </ul>
    </PostSection>
  );
}
